
import {
  ODataDateTime,
  ODataHeader,
  ODataString,
  ODataDate,
} from "pbas-vue-components";

const OptOutStatusHistoryHeaders=[
    new ODataHeader({
    title: "Message",
    type: new ODataString("Message",{
        getHtml: (item) => {
    return `<div style="white-space: normal; max-width: 500px;">${item.Message}</div>`;
    }
    }),
    visible: true,
    sortable: false,
    version:1,
    searchable: false
  }),
        new ODataHeader({
    title: "Status",
    type: new ODataString("Status"),
    visible: false,
    sortable: false,
    version:1,
    searchable: false
  }),
    new ODataHeader({
   type: new ODataString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    searchable: false,
  }),
    
]
export default OptOutStatusHistoryHeaders;